import { camelCase } from "lodash";

export function convertToCamelCase(obj: Record<string, any>): Record<string, any> {
  if (obj === null || typeof obj !== "object") {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => convertToCamelCase(item));
  }

  const camelCaseObj: any = {};
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const camelCaseKey = camelCase(key);
      camelCaseObj[camelCaseKey] = convertToCamelCase(obj[key]);
    }
  }

  return camelCaseObj;
}
